import { useSelector } from 'react-redux';

import { preSelectedIdsSelector, selectedItemsSelector } from '@air/redux-selected-items';

import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';

export type UsePendingSelectionCommitResult = {
  /**
   * Replace-click mousedown cleared `selectedItems` but mouseup has not committed the new
   * selection yet. Chrome should hold the last drawn state until then.
   */
  isPendingCommit: boolean;
};

/**
 * Replace-click mousedown clears `selectedItems` before mouseup commits the new selection.
 * Chrome that should not blink out during that window reads `isPendingCommit` and holds the
 * last drawn state until the commit lands — see `PrivateAgentSelectionBar` and
 * `PrivateWorkspaceAgentComposerScopeBar`.
 */
export const usePendingSelectionCommit = (): UsePendingSelectionCommitResult => {
  const selectedItems = useSelector(selectedItemsSelector);
  const preSelectedIds = useSelector(preSelectedIdsSelector);
  const selectAll = useViewsSelectAllStore((state) => state.selectAll);

  const hasCommittedSelection = selectedItems.length > 0 || selectAll;
  const hasPendingSelection = preSelectedIds.length > 0;

  return { isPendingCommit: hasPendingSelection && !hasCommittedSelection };
};
